import React from 'react';
import { RedirectToAppView } from "./redirect-to-app.view"

export const RedirectToApp = () => {
  return (<RedirectToAppView />)
}